import { useState } from 'react';
import SEO from '../components/SEO';
import heroImage from '../assets/hero.webp';
// Import the utility function
import { sendToWhatsApp } from '../components/whatsappUtils'; 

import seed from '../assets/seed.webp';
import fertilizer from '../assets/fertilizer.webp';
import कीटनाशक from '../assets/कीटनाशक.webp';
import machine from '../assets/machin.webp';
import irrigation from '../assets/irrigation.webp';
import bio from '../assets/bio.webp';
import seed1 from '../assets/seed1.webp';
import seed2 from '../assets/seed2.webp';
import seed3 from '../assets/seed3.webp';
import seed4 from '../assets/seed4.webp';
import Fertilizers1 from '../assets/Fertilizers1.webp';
import Fertilizers2 from '../assets/Fertilizers2.webp';
import Fertilizers3 from '../assets/Fertilizers3.webp';
import Fertilizers4 from '../assets/Fertilizers4.webp';
import machine1 from '../assets/machine1.webp';
import machine2 from '../assets/machine2.webp';
import machine3 from '../assets/machine3.webp';
import machine4 from '../assets/machine4.webp';
import Irrigation1 from '../assets/Irrigation1.webp';
import Irrigation2 from '../assets/Irrigation2.webp';
import Irrigation3 from '../assets/Irrigation3.webp';
import Irrigation4 from '../assets/Irrigation4.webp';
import bio1 from '../assets/bio1.webp';
import bio2 from '../assets/bio2.webp';
import bio3 from '../assets/bio3.webp';
import bio4 from '../assets/bio4.webp';
import Pesticides1 from '../assets/Pesticides1.webp';
import Pesticides2 from '../assets/Pesticides2.webp';
import Pesticides3 from '../assets/Pesticides3.webp';
import Pesticides4 from '../assets/Pesticides4.webp';

const AgricultureProducts = () => {
  const [selectedCategory, setSelectedCategory] = useState('सभी');
  const [priceRange, setPriceRange] = useState([0, 100000]);
  const [sortBy, setSortBy] = useState('popularity');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [expandedFaq, setExpandedFaq] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const productsPerPage = 8;

  // Sample data
  const categories = [
    { name: 'बीज', image: seed },
    { name: 'उर्वरक', image: fertilizer },
    { name: 'कीटनाशक', image: कीटनाशक },
    { name: 'कृषि यंत्र', image: machine },
    { name: 'सिंचाई उपकरण', image: irrigation },
    { name: 'जैविक उत्पाद', image: bio },
  ];

  const products = [
    // Seeds (4 products)
    {
      id: 1,
      name: 'गेहूँ का बीज (उन्नत किस्म)',
      price: 1200,
      category: 'बीज',
      image: seed1,
      description: 'उच्च उत्पादन देने वाली गेहूँ की उन्नत किस्म, रोग प्रतिरोधक क्षमता युक्त'
    },
    {
      id: 2,
      name: 'धान का हाइब्रिड बीज',
      price: 1500,
      category: 'बीज',
      image:  seed2,
      description: 'उच्च उत्पादकता वाला धान का बीज, कम पानी में अच्छी पैदावार'
    },
    {
      id: 3,
      name: 'मक्का संकर बीज',
      price: 1800,
      category: 'बीज',
      image:  seed3,
      description: 'उच्च प्रोटीन युक्त मक्का बीज, 90-100 दिन में तैयार'
    },
    {
      id: 4,
      name: 'सरसों उन्नत बीज',
      price: 1400,
      category: 'बीज',
      image: seed4,
      description: 'उच्च तेल सामग्री वाला सरसों बीज, रोग प्रतिरोधी किस्म'
    },
    // Fertilizers (4 products)
    {
      id: 5,
      name: 'जैविक खाद 25kg',
      price: 899,
      category: 'उर्वरक',
      image:  Fertilizers1,
      description: '100% प्राकृतिक जैविक खाद, मिट्टी की उर्वरता बढ़ाने के लिए उत्तम'
    },
    {
      id: 6,
      name: 'यूरिया खाद 50kg',
      price: 1200,
      category: 'उर्वरक',
      image:  Fertilizers2,
      description: 'नाइट्रोजन युक्त उर्वरक, फसलों की वृद्धि के लिए आवश्यक'
    },
    {
      id: 7,
      name: 'DAP खाद 50kg',
      price: 1500,
      category: 'उर्वरक',
      image:  Fertilizers3,
      description: 'फास्फोरस युक्त उर्वरक, जड़ विकास के लिए उत्तम'
    },
    {
      id: 8,
      name: 'पोटाश उर्वरक 50kg',
      price: 1300,
      category: 'उर्वरक',
      image:  Fertilizers4,
      description: 'पोटैशियम युक्त उर्वरक, फलों और फूलों के विकास के लिए'
    },
    // Pesticides (4 products)
    {
      id: 9,
      name: 'नीम आधारित कीटनाशक',
      price: 450,
      category: 'कीटनाशक',
      image:  Pesticides1,
      description: 'प्राकृतिक नीम से बना कीटनाशक, सभी फसलों के लिए सुरक्षित'
    },
    {
      id: 10,
      name: 'फफूंदनाशक स्प्रे',
      price: 550,
      category: 'कीटनाशक',
      image:  Pesticides2,
      description: 'फसलों को फफूंद से बचाने के लिए प्रभावी स्प्रे'
    },
    {
      id: 11,
      name: 'खरपतवार नाशक',
      price: 600,
      category: 'कीटनाशक',
      image:  Pesticides3,
      description: 'खेतों में अवांछित घास-फूस को नष्ट करने के लिए'
    },
    {
      id: 12,
      name: 'कीटनाशक पाउडर',
      price: 350,
      category: 'कीटनाशक',
      image:  Pesticides4,
      description: 'विभिन्न प्रकार के कीटों से फसल सुरक्षा के लिए'
    },
    // Machinery (4 products)
    {
      id: 13,
      name: 'मिनी ट्रैक्टर',
      price: 185000,
      category: 'कृषि यंत्र',
      image:  machine1,
      description: 'छोटे किसानों के लिए उपयुक्त शक्तिशाली मिनी ट्रैक्टर'
    },
    {
      id: 14,
      name: 'थ्रेशर मशीन',
      price: 45000,
      category: 'कृषि यंत्र',
      image:  machine2,
      description: 'फसल कटाई के बाद अनाज निकालने की मशीन'
    },
    {
      id: 15,
      name: 'सीड ड्रिल मशीन',
      price: 32000,
      category: 'कृषि यंत्र',
      image:  machine3,
      description: 'बीज बोने की आधुनिक मशीन, समय और श्रम की बचत'
    },
    {
      id: 16,
      name: 'हार्वेस्टर मशीन',
      price: 75000,
      category: 'कृषि यंत्र',
      image:  machine4,
      description: 'फसल कटाई के लिए स्वचालित मशीन, उच्च क्षमता'
    },
    // Irrigation (4 products)
    {
      id: 17,
      name: 'ड्रिप सिंचाई किट',
      price: 3500,
      category: 'सिंचाई उपकरण',
      image:  Irrigation1,
      description: 'पानी की बचत करने वाली आधुनिक सिंचाई प्रणाली'
    },
    {
      id: 18,
      name: 'स्प्रिंकलर सिस्टम',
      price: 4200,
      category: 'सिंचाई उपकरण',
      image:  Irrigation2,
      description: 'वर्षा की तरह पानी छिड़कने वाली प्रणाली'
    },
    {
      id: 19,
      name: 'सोलर वॉटर पंप',
      price: 25000,
      category: 'सिंचाई उपकरण',
      image: Irrigation3,
      description: 'सौर ऊर्जा से चलने वाला जल पंप, डीजल/बिजली की बचत'
    },
    {
      id: 20,
      name: 'पाइप सिंचाई सेट',
      price: 2800,
      category: 'सिंचाई उपकरण',
      image: Irrigation4,
      description: 'पारंपरिक सिंचाई के लिए उच्च गुणवत्ता वाली पाइप प्रणाली'
    },
    // Organic Products (4 products)
    {
      id: 21,
      name: 'जैविक कीटनाशक स्प्रे',
      price: 650,
      category: 'जैविक उत्पाद',
      image:  bio1,
      description: 'रासायनिक मुक्त जैविक कीटनाशक, फसलों के लिए सुरक्षित'
    },
    {
      id: 22,
      name: 'वर्मीकम्पोस्ट 10kg',
      price: 350,
      category: 'जैविक उत्पाद',
      image:  bio2,
      description: 'केंचुआ खाद, पोषक तत्वों से भरपूर'
    },
    {
      id: 23,
      name: 'जैविक फल स्प्रे',
      price: 750,
      category: 'जैविक उत्पाद',
      image:  bio3,
      description: 'फलों के लिए विशेष जैविक स्प्रे, रोग प्रतिरोधक'
    },
    {
      id: 24,
      name: 'जैविक ग्रोथ प्रमोटर',
      price: 550,
      category: 'जैविक उत्पाद',
      image:  bio4,
      description: 'पौधों की प्राकृतिक वृद्धि के लिए जैविक सहायक'
    }
  ];

  const faqs = [
    {
      question: 'बीज कब बोना चाहिए?',
      answer: 'बीज बोने का सही समय फसल और क्षेत्र के अनुसार अलग-अलग होता है। सामान्यतः रबी फसलों के बीज अक्टूबर-नवंबर में और खरीफ फसलों के बीज जून-जुलाई में बोए जाते हैं। मौसम और स्थानीय कृषि विभाग की सलाह के अनुसार बुवाई करें।'
    },
    {
      question: 'कीटनाशक की सही मात्रा कितनी हो?',
      answer: 'कीटनाशक की मात्रा फसल, कीट के प्रकार और उत्पाद के निर्देशों पर निर्भर करती है। हमेशा पैकेट पर दिए गए निर्देशों का पालन करें। सामान्यतः 200-300 मिलीलीटर प्रति एकड़ की दर से उपयोग किया जाता है। अधिक मात्रा फसल को नुकसान पहुंचा सकती है।'
    },
    {
      question: 'जैविक खाद के क्या लाभ हैं?',
      answer: 'जैविक खाद मिट्टी की संरचना सुधारती है, जल धारण क्षमता बढ़ाती है, सूक्ष्मजीवों की गतिविधि को प्रोत्साहित करती है, और लंबे समय तक मिट्टी की उर्वरता बनाए रखती है। यह रासायनिक खादों से सस्ती और पर्यावरण के लिए अनुकूल भी होती है।'
    },
    {
      question: 'ड्रिप सिंचाई क्यों महत्वपूर्ण है?',
      answer: 'ड्रिप सिंचाई पानी की बचत करने वाली सबसे कारगर विधि है। यह पौधों की जड़ों तक सीधे पानी पहुंचाती है, जिससे वाष्पीकरण और रिसाव से होने वाली पानी की बर्बादी रुकती है। इससे 30-50% तक पानी की बचत होती है और फसल उत्पादन भी बढ़ता है।'
    }
  ];

  // Filter and sort products
  const filteredProducts = products
    .filter(product => selectedCategory === 'सभी' || product.category === selectedCategory)
    .filter(product => product.price >= priceRange[0] && product.price <= priceRange[1])
    .sort((a, b) => {
      if (sortBy === 'price-low-high') return a.price - b.price;
      if (sortBy === 'price-high-low') return b.price - a.price;
      return 0;
    });

  // Pagination logic
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);
  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const openProductModal = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
    setQuantity(1);
  };

  // WhatsApp Handler Wrapper
  const handlePurchase = () => {
    if (selectedProduct) {
      sendToWhatsApp(selectedProduct.name, selectedProduct.price, selectedProduct.category, quantity);
    }
  };

  const toggleFaq = (index) => {
    setExpandedFaq(expandedFaq === index ? null : index);
  };

  const handleQuantityChange = (change) => {
    const newQuantity = quantity + change;
    if (newQuantity >= 1) {
      setQuantity(newQuantity);
    }
  };

  const getUnitText = (category) => {
    switch(category) {
      case 'बीज': return 'किलो';
      case 'कृषि यंत्र': return 'यूनिट';
      case 'सिंचाई उपकरण': return 'सेट';
      default: return 'पैक';
    }
  };

  return (
    <div className="font-sans bg-gray-50">
      <SEO 
        title="कृषि उत्पाद | उन्नत खेती के लिए उच्च गुणवत्ता वाले उत्पाद"
        description="उन्नत खेती के लिए उच्च गुणवत्ता वाले कृषि उत्पाद - बीज, उर्वरक, कीटनाशक, कृषि यंत्र और सिंचाई उपकरण"
        keywords="कृषि उत्पाद, बीज, उर्वरक, कीटनाशक, कृषि यंत्र, सिंचाई उपकरण, जैविक उत्पाद"
      />
        <div className="h-20"></div>

      {/* Hero Section */}
      <div className="relative h-96 bg-green-800 overflow-hidden">
        <img 
          src={heroImage}
          alt="हरा भरा खेत"
          className="w-full h-full object-cover opacity-70"
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 font-hind">हमारे कृषि उत्पाद</h1>
          <p className="text-xl md:text-2xl text-white mb-8 max-w-2xl">उन्नत खेती के लिए उच्च गुणवत्ता वाले उत्पाद</p>
        </div>
      </div>

      {/* Categories Grid */}
      <div className="container mx-auto px-4 py-12">
        <h2 className="text-3xl font-bold text-center mb-8 text-green-900 font-hind">हमारे उत्पाद श्रेणियाँ</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {categories.map((category, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition duration-300 cursor-pointer"
              onClick={() => {
                setSelectedCategory(category.name);
                setCurrentPage(1);
              }}
            >
              <div className="h-40 overflow-hidden">
                <img 
                  src={category.image} 
                  alt={category.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-4 text-center">
                <h3 className="font-semibold text-lg text-green-800">{category.name}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Filter and Products Section */}
      <div className="bg-gray-100 py-12">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center mb-8">
            <h2 className="text-3xl font-bold text-green-900 mb-4 md:mb-0 font-hind">
              {selectedCategory === 'सभी' ? 'हमारे उत्पाद' : selectedCategory}
            </h2>
            <div className="flex flex-col md:flex-row gap-4 w-full md:w-auto">
              <div className="bg-white p-3 rounded-lg shadow-sm">
                <label className="block text-sm font-medium text-gray-700 mb-1">श्रेणी</label>
                <select 
                  className="w-full p-2 border border-gray-300 rounded-md"
                  value={selectedCategory}
                  onChange={(e) => {
                    setSelectedCategory(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="सभी">सभी श्रेणियाँ</option>
                  {categories.map((cat, i) => (
                    <option key={i} value={cat.name}>{cat.name}</option>
                  ))}
                </select>
              </div>
              <div className="bg-white p-3 rounded-lg shadow-sm">
                <label className="block text-sm font-medium text-gray-700 mb-1">कीमत रेंज</label>
                <div className="flex items-center gap-2">
                  <span>₹{priceRange[0]}</span>
                  <input 
                    type="range" 
                    min="0" 
                    max="100000" 
                    step="1000"
                    value={priceRange[0]}
                    onChange={(e) => setPriceRange([parseInt(e.target.value), priceRange[1]])}
                    className="w-full"
                  />
                  <span>₹{priceRange[1]}</span>
                </div>
              </div>
              <div className="bg-white p-3 rounded-lg shadow-sm">
                <label className="block text-sm font-medium text-gray-700 mb-1">क्रमबद्ध करें</label>
                <select 
                  className="w-full p-2 border border-gray-300 rounded-md"
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                >
                  <option value="popularity">लोकप्रियता</option>
                  <option value="price-low-high">कीमत: कम से ज्यादा</option>
                  <option value="price-high-low">कीमत: ज्यादा से कम</option>
                </select>
              </div>
            </div>
          </div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {currentProducts.map((product) => (
              <div key={product.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition duration-300">
                <div className="h-48 overflow-hidden">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-4">
                  <h3 className="font-semibold text-lg mb-2 text-green-800">{product.name}</h3>
                  <div className="flex justify-between items-center">
                    <span className="text-xl font-bold text-green-700">₹{product.price}</span>
                    <button 
                      className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition duration-300"
                      onClick={() => openProductModal(product)}
                    >
                      अधिक जानकारी
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredProducts.length === 0 && (
            <div className="text-center py-12">
              <p className="text-xl text-gray-600">कोई उत्पाद नहीं मिला। कृपया फिल्टर बदलकर देखें।</p>
            </div>
          )}

          {/* Pagination */}
          {filteredProducts.length > productsPerPage && (
            <div className="flex justify-center mt-8">
              <nav className="inline-flex rounded-md shadow">
                <button
                  onClick={() => paginate(currentPage > 1 ? currentPage - 1 : 1)}
                  disabled={currentPage === 1}
                  className="px-4 py-2 rounded-l-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                >
                  पिछला
                </button>
                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i}
                    onClick={() => paginate(i + 1)}
                    className={`px-4 py-2 border-t border-b border-gray-300 ${currentPage === i + 1 ? 'bg-green-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'}`}
                  >
                    {i + 1}
                  </button>
                ))}
                <button
                  onClick={() => paginate(currentPage < totalPages ? currentPage + 1 : totalPages)}
                  disabled={currentPage === totalPages}
                  className="px-4 py-2 rounded-r-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                >
                  अगला
                </button>
              </nav>
            </div>
          )}
        </div>
      </div>
      
      {/* FAQs */}
      <div className="container mx-auto px-4 py-12">
        <h2 className="text-3xl font-bold text-center mb-8 text-green-900 font-hind">सामान्य प्रश्न</h2>
        <div className="max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <div key={index} className="mb-4 border border-gray-200 rounded-lg overflow-hidden">
              <button 
                className="flex justify-between items-center w-full text-left p-4 bg-gray-50 hover:bg-gray-100"
                onClick={() => toggleFaq(index)}
              >
                <h3 className="text-lg font-semibold text-green-800">{faq.question}</h3>
                <svg 
                  className={`w-5 h-5 text-green-600 transform transition-transform ${expandedFaq === index ? 'rotate-180' : ''}`} 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {expandedFaq === index && (
                <div className="p-4 bg-white">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Product Modal */}
      {showModal && selectedProduct && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-start mb-4">
                <h2 className="text-2xl font-bold text-green-900">{selectedProduct.name}</h2>
                <button 
                  onClick={() => setShowModal(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <img 
                    src={selectedProduct.image} 
                    alt={selectedProduct.name}
                    className="w-full h-64 object-cover rounded-lg"
                  />
                </div>
                <div>
                  <div className="text-2xl font-bold text-green-700 mb-6">
                    ₹{selectedProduct.price * quantity} ({quantity} {getUnitText(selectedProduct.category)})
                  </div>

                  <div className="mb-6">
                    <h3 className="font-semibold text-lg mb-2 text-green-800">विवरण</h3>
                    <p className="text-gray-700">{selectedProduct.description}</p>
                  </div>

                  <div className="mb-6">
                    <h3 className="font-semibold text-lg mb-2 text-green-800">उपयोग विधि</h3>
                    <p className="text-gray-700">उत्पाद के पैकेट पर दिए गए निर्देशों का पालन करें। सामान्यतः 1 एकड़ भूमि के लिए {selectedProduct.category === 'बीज' ? '10-15 किलो बीज' : selectedProduct.category === 'उर्वरक' ? '25-50 किलो उर्वरक' : selectedProduct.category === 'कीटनाशक' ? '200-300 मिलीलीटर' : 'उपयुक्त मात्रा'} का प्रयोग करें।</p>
                  </div>

                  <div className="flex items-center mb-6">
                    <span className="mr-4 font-medium">मात्रा:</span>
                    <div className="flex items-center border border-gray-300 rounded-md">
                      <button 
                        className="px-3 py-1 text-xl"
                        onClick={() => handleQuantityChange(-1)}
                      >-</button>
                      <span className="px-4 py-1 border-x border-gray-300">{quantity}</span>
                      <button 
                        className="px-3 py-1 text-xl"
                        onClick={() => handleQuantityChange(1)}
                      >+</button>
                    </div>
                  </div>

                  <div className="flex gap-4">
                    {/* Updated WhatsApp Purchase Button */}
                    <button 
                      onClick={handlePurchase}
                      className="bg-green-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-700 transition duration-300 flex-1 flex items-center justify-center gap-2"
                    >
                      <span> व्हाट्सएप पर खरीदें </span>
                      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                         <path d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.711 2.598 2.664-.698c.969.585 1.802.89 2.796.89 3.18 0 5.767-2.587 5.767-5.766.001-3.182-2.585-5.777-5.767-5.777zm3.391 8.246c-.169.488-1.025.86-1.423.905-.333.037-.775.057-2.316-.549-1.393-.548-2.385-2.006-2.518-2.185-.131-.176-.6-1.002-.6-1.91 0-.909.436-1.35.6-1.53.164-.179.525-.262.799-.262.083 0 .17.002.247.009.223.02.321.055.431.32.148.351.493 1.21.536 1.297.043.088.072.191.01.299-.062.108-.094.175-.187.279-.093.104-.196.231-.279.31-.093.091-.19.191-.082.378.108.187.478.791 1.026 1.277.701.622 1.291.815 1.474.904.183.088.291.076.4-.049.109-.125.467-.545.592-.733.125-.188.25-.157.419-.094.17.063 1.077.508 1.261.6.185.093.308.14.351.216.043.076.043.441-.126.929z"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AgricultureProducts;